import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgxSmartModalComponent } from 'ngx-smart-modal';
import { WebsiteTextingSubscriptionService } from '../../core/subscription/website-texting-subscription.service';
import { MessageService } from 'primeng/api';
import { UserService } from '../../core/user/user.service';
import { AgentService } from '../../core/agent/agent.service';
import { SubscriptionService } from '../../core/subscription/subscription.service';

@Component({
  selector: 'rosie-website-texting-subscribe-modal',
  templateUrl: './website-texting-subscribe-modal.component.html',
  styleUrls: ['./website-texting-subscribe-modal.component.scss'],
  standalone: false
})
export class WebsiteTextingSubscribeModalComponent {
  @ViewChild('wtSubscribeModal') modal: NgxSmartModalComponent;
  @Output() subscribed = new EventEmitter<void>();

  isSubscribing = false;
  showPromoInput = false;
  isValidatingPromo = false;
  promoValidationState: 'idle' | 'valid' | 'invalid' = 'idle';

  constructor(
    private wtSubscription: WebsiteTextingSubscriptionService,
    private messageService: MessageService,
    private user: UserService,
    private agent: AgentService,
    private subscription: SubscriptionService
  ) { }


  get isEligibleForWtPromo(): boolean {
    return this.user.isEligibleForWtPromo;
  }

  get isTrialing(): boolean {
    return this.subscription.isTrialing;
  }

  get trialEndsAt(): string | undefined {
    return this.subscription.subscriptionData?.trialEndsAt;
  }

  open(): void {
    this.isSubscribing = false;
    this.modal.open();
  }

  togglePromoInput(): void {
    this.showPromoInput = true;
  }

  close(): void {
    this.modal.close();
  }

  subscribe(): void {
    if (this.isSubscribing) return;

    this.isSubscribing = true;

    this.wtSubscription.subscribe().subscribe({
      next: (res) => {
        if (res?.confirmationUrl) {
          // Shopify requires merchant approval — redirect to Shopify
          window.open(res.confirmationUrl, '_top');
          return;
        }
        this.isSubscribing = false;
        this.messageService.add({
          severity: 'success',
          detail: 'Website Texting has been enabled!',
          life: 3000
        });
        this.subscribed.emit();
        this.close();
      },
      error: (error) => {
        this.isSubscribing = false;
        const errorMessage = error?.error?.message || error?.message || error;
        let displayedError = error?.includes('yearly') ? errorMessage : (!this.agent.phoneNumber ? 'Failed to enable website texting. Your account does not have a phone number. Re-issue a phone number and try again.' : 'Failed to enable SMS. Please try again.');
        this.messageService.add({
          severity: 'error',
          summary: 'SMS Enable Failed',
          detail: displayedError,
          life: 10000
        });
      }
    });
  }
}
